import React, { useEffect, useState } from 'react';
import { withTranslation } from "react-i18next";



import CurrencyBasic from '../../components/basic/CurrencyBasic';
import LayoutSection from '../../components/NavigationAndLayouts/LayoutSection';

const ValleTest = (props) => {
 
  const [centimos, setCentimos] = React.useState(1234567888);
 
  useEffect(() => {
    // Código dentro del useEffect si es necesario
  }, []); // La dependencia vacía indica que esto solo se ejecuta al montar el componente

  return (
   
  <LayoutSection>
      // Este valor es almacenado como centavos internamente {centimos}
      <CurrencyBasic
        label="Cantidad en centavos"
        value={centimos}
        onChange={(e) => setCentimos(e.target.value)} // El valor siempre es almacenado como un string de centavos (por ejemplo: "123456" para 1234,56)
        locale="es-ES" // Puedes cambiar el formato por el locale que necesites (es-ES para español)
        decimalScale={2} // Decimales (en caso de que el usuario ingrese decimales)
        fixedDecimalScale={true} // Siempre mostrar dos decimales
        allowNegative={false} // Si quieres permitir números negativos
      />
    </LayoutSection>
  );
};

export default withTranslation()(ValleTest);
